var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"displacement"},[_c('div',{staticClass:"angle"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(this.angle)+"°")]),_c('i',{staticClass:"icon el-icon-caret-bottom"})]),_c('div',{ref:"liquidEchart",staticClass:"liquidData"})])
}
var staticRenderFns = []

export { render, staticRenderFns }